import { render, staticRenderFns } from "./ActivityInsights.vue?vue&type=template&id=13716b6e&"
import script from "./ActivityInsights.vue?vue&type=script&lang=js&"
export * from "./ActivityInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports